export const volunteerData = [
  {
    id: 1,
    category: "leadership",
    date: "Jun 2025 - Present",
    title: "Technical Lead",
    place: "PyCon Senegambia | Banjul, The Gambia",
    desc: "Led technical preparations for the PyCon Senegambia conference, ensuring a smooth experience for speakers and attendees. Designed and developed the official conference website with an integrated ticketing and registration system. Collaborated with the executive team on event planning, budgeting, and financial disbursements.",
    image: require("../../assets/hello.png")
  },
  {
    id: 2,
    category: "leadership",
    date: "Aug 2023 - Aug 2024",
    title: "Financial Secretary",
    place: "International Students’ Association | KNUST, Ghana",
    desc: "Prepared budgets, oversaw financial transactions, and produced financial reports for the association. Ensured transparency and compliance with financial procedures while collaborating with the executive team to support event planning and manage funding allocations.",
    image: require("../../assets/isa.jpeg")
  },
  {
    id: 3,
    category: "volunteering",
    date: "Aug 2022 - Aug 2024",
    title: "Brand Ambassador",
    place: "Mastercard Foundation Scholars Foundation | Arizona, USA",
    desc: "Built strong relationships with scholars to increase engagement and loyalty. Educated scholars about program benefits and onboarded new participants onto the platform. Acted as a liaison between scholars and program leadership, providing feedback to improve program strategies.",
    image: require("../../assets/asu.jpeg")
  },
  {
    id: 4,
    category: "leadership",
    date: "Jun 2021 - Aug 2023",
    title: "Financial Secretary & Head of Media",
    place: "Gambian Students’ Association | KNUST, Ghana",
    desc: "Managed the association’s accounts and facilitated the production of the first batch of official association t-shirts. Established and managed the association’s social media platforms, while generating revenue and ensuring financial accountability as a signatory to association funds.",
    image: require("../../assets/gamtech.jpeg")
  }
];